import React from 'react'

// @material-ui
import { Slider } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// style
import simpleSliderStyle from './simpleSliderStyle'

class SimpleSlider extends React.PureComponent {
  render() {
    const { classes, value, target, sliderProps } = this.props

    const percent = Math.trunc((value * 100) / target)
    return (
      <Slider
        className={classes.slider}
        classes={{
          root: classes.root,
          track: classes.track,
          rail: classes.rail,
          thumb: classes.thumb,
        }}
        value={percent}
        aria-labelledby="simple-slider"
        thumb={<div className={classes.sliderThumb} />}
        {...sliderProps}
      />
    )
  }
}
export default withStyles(simpleSliderStyle)(SimpleSlider)
